import { render, staticRenderFns } from "./ResellerDetailsPlate.vue?vue&type=template&id=351ce4bc"
import script from "./ResellerDetailsPlate.vue?vue&type=script&lang=js"
export * from "./ResellerDetailsPlate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports